module.exports = __webpack_public_path__ + "static/media/structure.22ee1469.png";


//////////////////
// WEBPACK FOOTER
// ./src/Conviot/Role/img/structure.png
// module id = 191
// module chunks = 0